import { combineReducers } from '@reduxjs/toolkit'

import artifactsReducer, { ArtifactsState } from './artifactsReducer'
import mentorsReducer, { MentorsState } from './mentorsReducer'
import sessionReducer, { SessionState } from './sessionReducer'
import twinReducer, { twinState } from './twinReducer'
import userReducer, { UserState } from './userReducer'

const rootReducer = combineReducers({
  sessionReducer,
  userReducer,
  mentorsReducer,
  artifactsReducer,
  twinReducer,
})

export default rootReducer

export interface RootState {
  sessionReducer: SessionState
  userReducer: UserState
  mentorsReducer: MentorsState
  artifactsReducer: ArtifactsState
  twinReducer: twinState
}
